import { useState } from "react";
import { Menu, ShoppingCart, X } from "lucide-react";
import { ASSETS, scrollToSection } from "@/data/products";

const NAV = [
  { label: "Home", id: "home" },
  { label: "About Us", id: "about" },
  { label: "Products", id: "products" },
  { label: "How to Order", id: "how-to-order" },
  { label: "Contact", id: "contact" },
];

export default function Header({ cartCount, onOpenCart }) {
  const [menuOpen, setMenuOpen] = useState(false);

  const go = (id) => {
    setMenuOpen(false);
    scrollToSection(id);
  };

  return (
    <header className="sticky top-0 z-50 border-b border-charcoal/10 bg-cream/95 backdrop-blur">
      <div className="mx-auto flex max-w-6xl items-center justify-between px-4 py-3 sm:px-6">
        <button
          type="button"
          onClick={() => go("home")}
          className="flex items-center"
          aria-label="RIMBARA MAJU — go to home"
          data-testid="header-logo"
        >
          <img
            src={ASSETS.logo}
            alt="RIMBARA MAJU SDN BHD logo"
            className="h-11 w-auto object-contain"
          />
        </button>

        <nav className="hidden items-center gap-7 md:flex" aria-label="Main navigation">
          {NAV.map((item) => (
            <button
              key={item.id}
              type="button"
              onClick={() => go(item.id)}
              className="text-sm font-medium text-charcoal/80 transition-colors hover:text-forest"
              data-testid={`nav-${item.id}`}
            >
              {item.label}
            </button>
          ))}
        </nav>

        <div className="flex items-center gap-2">
          <button
            type="button"
            onClick={onOpenCart}
            className="relative rounded-full p-2.5 text-charcoal transition-colors hover:bg-forest/10"
            aria-label={`Open cart, ${cartCount} items`}
            data-testid="cart-open-button"
          >
            <ShoppingCart className="h-5 w-5" aria-hidden="true" />
            {cartCount > 0 && (
              <span
                className="absolute -right-0.5 -top-0.5 flex h-5 min-w-5 items-center justify-center rounded-full bg-bronze px-1 text-[11px] font-bold text-white"
                data-testid="cart-count-badge"
              >
                {cartCount}
              </span>
            )}
          </button>
          <button
            type="button"
            className="rounded-full p-2.5 text-charcoal transition-colors hover:bg-forest/10 md:hidden"
            onClick={() => setMenuOpen((o) => !o)}
            aria-label={menuOpen ? "Close menu" : "Open menu"}
            aria-expanded={menuOpen}
            data-testid="mobile-menu-button"
          >
            {menuOpen ? <X className="h-5 w-5" /> : <Menu className="h-5 w-5" />}
          </button>
        </div>
      </div>

      {menuOpen && (
        <nav
          className="border-t border-charcoal/10 bg-cream px-4 py-3 md:hidden"
          aria-label="Mobile navigation"
          data-testid="mobile-menu"
        >
          {NAV.map((item) => (
            <button
              key={item.id}
              type="button"
              onClick={() => go(item.id)}
              className="block w-full rounded-lg px-3 py-2.5 text-left text-sm font-medium text-charcoal/85 transition-colors hover:bg-forest/10"
              data-testid={`mobile-nav-${item.id}`}
            >
              {item.label}
            </button>
          ))}
        </nav>
      )}
    </header>
  );
}
